import { render, staticRenderFns } from "./IdentifiantsForm.vue?vue&type=template&id=71e7a890"
import script from "./IdentifiantsForm.vue?vue&type=script&lang=js"
export * from "./IdentifiantsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports